import {
  COMPANIES_FETCH_LOADING, COMPANIES_FETCH_SUCCEED,
  WORKER_ADD_LOADING
} from "../actions/workerActions";

const INITIAL_STATE = {
  workerLoading: false,
  companies: [],
  companiesLoading: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case WORKER_ADD_LOADING:
      return {
        ...state,
        workerLoading: action.payload,
      };
    case COMPANIES_FETCH_LOADING:
      return {
        ...state,
        companiesLoading: action.payload
      }
    case COMPANIES_FETCH_SUCCEED:
      return {
        ...state,
        companies: action.payload
      }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/worker/reducers/WorkerFormReducer.js